import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function DailyHot() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-3">
            <span className="w-1.5 h-5 bg-primary-500 rounded-full"></span>
            <span className="text-primary-600 text-sm font-medium tracking-wider">HOT</span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 tracking-tight">
            每日大赛
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            今日最热吃瓜 · 实时更新 · 不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] cursor-pointer"
            >
              <img
                src={article.coverImage}
                alt={article.title}
                title={`吃瓜网每日大赛 - ${article.title}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-medium mb-3">
                  {article.category}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-white leading-snug line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-white/70 text-xs md:text-sm line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 text-white/50 text-xs">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>

              {index === 0 && (
                <div className="absolute top-4 left-4 bg-primary-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  爆
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}